import { Formik, Field, isEmptyArray } from "formik";
import React, { useState, useRef, useContext, useEffect } from "react";
import { Card, Form, Modal } from "react-bootstrap";
import {
  getPathWithParam,
  MANAGE_MAPPER_ROUTES,
  manageMapperFormNames,
  mapperFormFields,
  FLOW_TYPES,
  ROUTES,
  yesNoOptions,
  sourceTypeData,
  fileFormatData,
  required,
  returnOnlyIfBoolean,
  stringToFunctionConverter,
  PassthorughTargetfileFormatData,
} from "../../../utils";
import {
  ManageMapperLayout,
  FieldDropSide,
  SearchableList,
  FieldInput,
  FieldButtonGroup,
  FieldInputPassword,
  LoaderWrapper,
  EncryptionDetails,
  FTPDetails,
  FileNameDropSide,
  FieldInputNumber,
  UploadComponent,
  AddToolTip,
} from "../../../components";
import FixedWidthSwitchComponent from "../../../components/FixedWidthSwitchComponent";
import {
  onSaveOutputTarget,
  onSavePassthroughTarget,
  onSaveSplit,
} from "../../../services";
import {
  manageMapperStore,
  setManageMapperToastInfo,
  MANAGE_MAPPER_POST_API_ERROR,
  setMapperPostResponse,
  setOldFileName,
  UploadTargetFile,
  setFileUploadData,
} from "../../../contexts";
import { useDeepEffect, useRouterParams } from "../../../abstracts";
import { get, isEmpty, values } from "lodash";
import ConfigureFileSlider from "../MapAndTransformOutput/ConfigureFileSlider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/pro-light-svg-icons";
import { isNullOrUndefined } from "@microsoft/applicationinsights-core-js";
const SplitContainer = (props) => {
  const { history } = props;
  const { state, dispatch } = useContext(manageMapperStore);
  const { flow, profileId, mapType } = useRouterParams();
  const isEdit = flow === FLOW_TYPES.EDIT || profileId;
  const data = !isEmpty(
    get(state, "api.fileuploadData.mappingConfiguration", {})
  )
    ? get(state, "api.fileuploadData.mappingConfiguration", {})
    : get(state, "api.data", {});
  const formName = manageMapperFormNames.SPLITS;
  const fields = mapperFormFields[formName];
  const headerMapJson = get(data, "headerMapJson", null);
  const fieldHeadersJson = JSON.parse(headerMapJson);
  const [dataLoading, setDataLoading] = useState(false);
  const [slideShow, setSlideShow] = useState(false);
  const [saveData, setSaveData] = useState([]);
  const [mappedData, setMappedData] = useState([]);
  const [configureValue, setConfigureValue] = useState();
  const [checkSubmit, setCheckSubmit] = useState(true);
  const [filteredData, setFilteredData] = useState();
  const initialFileName = !isEmpty(data?.splitModelJson)
    ? JSON.parse(get(data, "splitModelJson", ""))
    : null;
  useEffect(() => {
    const splitHeaderMapJson = fieldHeadersJson?.map((data) => {
      return {
        ...data,
        fieldName: data.fieldName.substring(1),
        checked: initialFileName?.SourceFields?.includes(
          data.fieldName.substring(1)
        )
          ? true
          : false,
      };
    });
    setFilteredData(splitHeaderMapJson);
  }, [headerMapJson]);
  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      link: ROUTES.MAPPER_HOME,
    },
    {
      label: "Next",
      variant: "primary",
      type: "submit",
    },
  ];
  var checkedFields = filteredData?.filter((_) => _.checked);
  const initialValues = {};
  const saveSplitApiCall = (payload) => {
    onSaveSplit(payload)
      .then((res) => {
        setDataLoading(false);
        if (!isEmpty(res)) {
          const outputTemplateMaps = JSON.parse(res["outputProfile"])[
            "OutputTemplateMaps"
          ];
          res = { ...res, outputTemplateMaps };
          dispatch(
            setFileUploadData({
              mappingConfiguration: res,
            })
          );
          dispatch(setMapperPostResponse(res));
          dispatch(
            setManageMapperToastInfo({
              showToast: true,
              toastMessage: "Data saved successfully",
            })
          );
          history.push(
            `${MANAGE_MAPPER_ROUTES.OVERVIEW}/${mapType}/${profileId}`
          );
        } else {
          dispatch({
            type: MANAGE_MAPPER_POST_API_ERROR,
            payload: "Something went wrong! please try again.",
          });
        }
      })
      .catch((err) => {
        setDataLoading(false);
        dispatch({
          type: MANAGE_MAPPER_POST_API_ERROR,
          payload: "Something went wrong! please try again.",
        });
      });
  };
  function onSubmit(values) {
    var sourceFieldsPayload = checkedFields?.map((obj) => obj.fieldName);
    const payload = {
      profileId: profileId,
      isSplitApplied: values?.isSplitModel,
      splitModelJson: values?.isSplitModel
        ? {
            fileNameExpression: values?.fileName,
            sourceFields: sourceFieldsPayload,
          }
        : {},
    };
    if (
      !isNullOrUndefined(values?.fileName) &&
      !isEmptyArray(checkedFields) &&
      values?.isSplitModel
    ) {
      saveSplitApiCall(payload);
    } else if (!values?.isSplitModel) {
      saveSplitApiCall(payload);
    } else {
      setCheckSubmit(false);
    }
  }
  const selectTargetFields = (fieldData) => {
    setFilteredData(
      filteredData.map((itm, ind) => {
        return {
          ...itm,
          checked: fieldData == itm.fieldName ? !itm.checked : itm.checked,
        };
      })
    );
  };
  return (
    <Formik
      initialValues={{
        ...initialValues,
        [fields.configureOption]: 3,
        [fields.isSplitModel]: get(data, "isSplitApplied", false),
        [fields.fileName]: get(initialFileName, "FileNameExpression", null),
        [fields.filteredName]: !isNullOrUndefined(
          get(initialFileName, "SourceFields", [])
        )
          ? get(initialFileName, "SourceFields", [])
          : [],
      }}
      enableReinitialize
      onSubmit={onSubmit}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        errors,
        values,
        touched,
        setFieldValue,
        setValues,
        handleChange,
        handleSubmit,
      }) => {
        return (
          <Form autoComplete="off" className="h-100" onSubmit={handleSubmit}>
            <LoaderWrapper isLoading={dataLoading}>
              <ManageMapperLayout layoutHeader="Split" buttons={buttons}>
                <div>
                  <div
                    style={{
                      paddingBottom: "0.5rem",
                      color: "#494F5A",
                      fontSize: "18px",
                      fontWeight: "550",
                    }}
                  >
                    Apply Split
                  </div>
                  <div style={{ display: "flex" }}>
                    <Field
                      isRequired
                      name={fields.isSplitModel}
                      size="md"
                      className="bg-transparent p-0"
                      options={yesNoOptions}
                      selectedValue={values[fields.isSplitModel]}
                      onChange={(value) => {
                        setFieldValue(fields.isSplitModel, value);
                      }}
                      component={FieldButtonGroup}
                    />
                  </div>
                  {values[fields.isSplitModel] ? (
                    <div>
                      <span className="fw-500 ft-12">Source Field</span>
                      {!checkSubmit && isEmptyArray(checkedFields) && (
                        <span className="mapperErrorMessage ml-2">
                          Required
                        </span>
                      )}
                      <div className="mb-1 px-4 py-2 w-50 rounded split-field">
                        {filteredData?.map((element, ind) => {
                          return (
                            <div>
                              <p
                                style={{ fontSize: "12px" }}
                                className="py-2 m-0"
                              >
                                <div className="d-flex">
                                  <input
                                    custom
                                    name={fields.filteredName}
                                    type="checkbox"
                                    value={values[fields.filteredName]}
                                    checked={element.checked}
                                    onChange={() => {
                                      selectTargetFields(element.fieldName);
                                      // setFieldValue(
                                      //   fields.filteredName,
                                      //   values[fields.filteredName]?.includes(
                                      //     element.fieldName
                                      //   )
                                      //     ? values[fields.filteredName]?.filter(
                                      //         (_) => _ != element.fieldName
                                      //       )
                                      //     : [
                                      //         ...values[fields.filteredName],
                                      //         element.fieldName,
                                      //       ]
                                      // );
                                    }}
                                  />
                                  <span className="ml-1 w-50">
                                    <AddToolTip
                                      name={
                                        element.fieldName[0] == "/"
                                          ? element.fieldName.substring(1)
                                          : element.fieldName
                                      }
                                    />
                                  </span>
                                </div>
                              </p>
                            </div>
                          );
                        })}
                      </div>

                      <div
                        style={{
                          display: "block",
                          fontSize: "18px",
                          fontWeight: "500",
                          alignItems: "center",
                          paddingBottom: "0",
                        }}
                      ></div>
                      <div
                        style={{
                          display: "block",
                          // font: "Poppins",
                          fontSize: "18px",
                          fontWeight: "500",
                          alignItems: "center",
                          paddingBottom: "0",
                        }}
                      >
                        <div>
                          {values[fields.configureOption] == 3 && (
                            <ConfigureFileSlider
                              isSplitConfigured={values[fields.isSplitModel]}
                              configureValue={configureValue}
                              setConfigureValue={setConfigureValue}
                              slideShow={slideShow}
                              setSlideShow={setSlideShow}
                              dataModel={4}
                              handleChange={handleChange}
                              saveData={saveData}
                              setSaveData={setSaveData}
                              mappedData={mappedData}
                              fileName={values[fields.fileName]}
                              setFieldValuesParent={setFieldValue}
                              setMappedData={setMappedData}
                              setCheckSubmit={setCheckSubmit}
                              isDefaultHeader = {false}
                            />
                          )}

                          {values[fields.configureOption] == 3 && (
                            <div className="mb-5">
                              {" "}
                              <div className="file-name-header">File Name</div>
                              <div
                                className={`${
                                  values?.fileName?.length >= 150 &&
                                  !checkSubmit
                                    ? "errorTargetCustomBox"
                                    : "targetCustomBox"
                                } mt-20`}
                              >
                                <div
                                  style={{
                                    width: "80%",
                                  }}
                                >
                                  <div className="targetSelectedCustomData">
                                    <AddToolTip name={values.fileName} />
                                  </div>
                                </div>
                                <div className="customEdit-align">
                                  <FontAwesomeIcon
                                    className="customEdit"
                                    icon={faEdit}
                                    onClick={(evt) => {
                                      evt.stopPropagation();
                                      setSlideShow(true);
                                    }}
                                  ></FontAwesomeIcon>
                                </div>
                              </div>
                              {!values?.fileName && !checkSubmit && (
                                <div className="mapperErrorMessage">
                                  Required
                                </div>
                              )}
                              {values?.fileName?.length >= 150 &&
                                !checkSubmit && (
                                  <div className="mapperErrorMessage">
                                    Maximum character length should be 150
                                  </div>
                                )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="FilterUnavailable">Split not applied</div>
                  )}
                </div>
              </ManageMapperLayout>
            </LoaderWrapper>
          </Form>
        );
      }}
    </Formik>
  );
};

export default SplitContainer;
